import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@core/services/auth/auth.service';

export const UnAuthGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.token) {
    // If user is authenticated, redirect to dashboard or home
    router.navigateByUrl('/brand/channel-mix');
    return false;
  }

  return true; // Allow access to login page
};
